export const translations = {
  ru: {
    meta: {
      title: 'POSTMAN — доставка по Казахстану',
      description: 'Курьерская доставка документов и посылок по Казахстану с онлайн-отслеживанием.',
    },
    common: {
      home: 'Главная',
      tracking: 'Отслеживание',
      services: 'Услуги',
      contacts: 'Контакты',
      cabinet: 'Личный кабинет',
      close: 'Закрыть',
      noInfo: 'Нет информации',
      search: 'Найти',
      searching: 'Ищем…',
      discussDelivery: 'Обсудить доставку',
    },
    header: {
      homeLabel: 'POSTMAN, главная',
      openMenu: 'Открыть меню',
      closeMenu: 'Закрыть меню',
      navigationLabel: 'Основная навигация',
      languageLabel: 'Язык сайта',
    },
    footer: {
      description: 'Курьерская доставка отправлений по всему Казахстану.',
      navigation: 'Навигация',
      trackShipment: 'Отследить отправление',
      contact: 'Связаться',
      company: 'ТОО «POSTMAN»',
      madeBy: 'Сделано студией',
      privacy: 'Обработка персональных данных',
    },
    home: {
      businessQuestion: 'Нужна доставка для бизнеса?',
      discussTask: 'Обсудить задачу →',
      eyebrow: 'Курьерская служба по Казахстану',
      titleBefore: 'Доставка, которую видно',
      titleEmphasis: 'на каждом этапе',
      lead: 'Организуем доставку документов и посылок по всему Казахстану. Контролируйте статус отправления и получайте актуальную информацию на каждом этапе.',
      trackLabel: 'Отследить отправление',
      trackPlaceholder: 'Номер накладной или заказа',
      check: 'Проверить',
      trackingRequired: 'Введите номер накладной или заказа.',
      trackingNotFound: 'Отправление не найдено. Проверьте номер полностью или повторите запрос позже.',
      heroAlt: 'Курьер POSTMAN с посылкой рядом с автомобилем доставки',
      doorToDoor: 'Доставка от двери до двери',
      resultEyebrow: 'Результат поиска',
      resultTitle: 'Отслеживание отправления',
      closeResult: 'Закрыть результат отслеживания',
      trust: ['Собственный автопарк', 'Детальное отслеживание', 'Доставка до двери', 'По всему Казахстану'],
      servicesEyebrow: 'Что доставляем',
      servicesTitle: 'Логистика без лишней сложности',
      allServices: 'Все услуги →',
      serviceCards: [
        { title: 'Экспресс-доставка', text: 'Документы и посылки между городами Казахстана с понятными сроками и статусами.' },
        { title: 'Доставка для бизнеса', text: 'Регулярные отправки, собственный автопарк и личный кабинет для управления заказами.' },
        { title: 'До удалённых адресов', text: 'Крупные города, районные центры, сёла и аулы в единой сети доставки.' },
      ],
      learnMore: 'Узнать больше',
      partnerEyebrow: 'Проверено большим объёмом',
      partnerTitle: 'Доставка для партнёрских сетей по Казахстану',
      partnerLogosLabel: 'Партнёры POSTMAN',
      partnerText: 'Тысячи заказов проходят через нашу сеть. От приёмки до вручения каждый этап фиксируется в системе.',
      stepsEyebrow: 'Как это работает',
      stepsTitle: 'Три шага до получателя',
      steps: [
        { title: 'Создайте отправление', text: 'Оставьте заявку или оформите заказ в личном кабинете.' },
        { title: 'Передайте курьеру', text: 'Мы заберём отправление и зарегистрируем его в системе.' },
        { title: 'Следите онлайн', text: 'Проверяйте движение и итог вручения по номеру накладной.' },
      ],
      ctaEyebrow: 'Есть задача?',
      ctaTitle: 'Подберём маршрут и формат доставки',
      ctaText: 'Расскажите, что и куда нужно отправлять. Ответим и предложим подходящий вариант.',
      ctaButton: 'Написать нам',
    },
    servicesPage: {
      eyebrow: 'Услуги POSTMAN',
      title: 'Доставка по Казахстану для людей и бизнеса',
      lead: 'Берём на себя путь от приёмки до вручения и показываем движение отправления в онлайн-трекинге.',
      items: [
        ['Документы', 'Защитные конверты и быстрая доставка деловой корреспонденции.'],
        ['Посылки', 'Отправления для частных клиентов и интернет-магазинов по Казахстану.'],
        ['Регулярные рейсы', 'Предсказуемая логистика для компаний с постоянным объёмом отправок.'],
        ['Адресная доставка', 'Забор и вручение по адресу, включая удалённые населённые пункты.'],
      ],
      rates: 'Тарифы',
      ratesTitle: 'Стоимость зависит от маршрута и параметров отправления',
      ratesText: 'Для точного расчёта укажите город отправления, город получения, вес, размеры и желаемый срок.',
      getQuote: 'Получить расчёт',
      beforeSending: 'Перед отправкой',
      packingTitle: 'Как правильно упаковать',
      packing: [
        'Укажите контактные данные на каждом месте.',
        'Используйте плотную коробку подходящего размера.',
        'Заполните пустоты, чтобы вложение не перемещалось.',
        'Заклейте места вскрытия и промаркируйте хрупкий груз.',
      ],
      helpTitle: 'Нужна помощь с нестандартным отправлением?',
      helpText: 'Опишите задачу, и менеджер подскажет по упаковке, срокам и маршруту.',
      contactUs: 'Связаться с нами →',
    },
    contactsPage: {
      eyebrow: 'Контакты',
      title: 'Давайте обсудим вашу доставку',
      lead: 'Ответим на вопрос по отправлению, рассчитаем маршрут или подготовим предложение для бизнеса.',
      phone: 'Телефон',
      call: 'Позвонить →',
      email: 'Электронная почта',
      write: 'Написать →',
      office: 'Головной офис',
      address: 'РК, индекс A20F2X1 (050034), г. Алматы, Жетысуский район, ул. Ниязбекова, дом 33',
      map: 'Открыть карту ↗',
      requisites: 'Реквизиты',
      requisitesLabels: ['Компания', 'РНН', 'БИН', 'БИК', 'Банк', 'IBAN', 'Свидетельство по НДС', 'Юридический адрес', 'Директор'],
      formEyebrow: 'Форма обратной связи',
      formTitle: 'Напишите нам',
      requiredHint: 'Поля со звёздочкой обязательны.',
      firstName: 'Имя *',
      lastName: 'Фамилия',
      organization: 'Компания',
      phoneRequired: 'Телефон *',
      emailRequired: 'Email *',
      message: 'Сообщение *',
      messagePlaceholder: 'Расскажите, чем мы можем помочь',
      agreementBefore: 'Я согласен(а) на',
      agreementLink: 'обработку персональных данных',
      agreementError: 'Подтвердите согласие на обработку персональных данных.',
      sending: 'Отправляем…',
      submit: 'Отправить сообщение',
      success: 'Сообщение отправлено. Мы свяжемся с вами в рабочее время.',
      error: 'Не удалось отправить сообщение. Позвоните нам: {phone}.',
    },
    trackingPage: {
      eyebrow: 'Актуальные данные из системы',
      title: 'Отслеживание отправления',
      lead: 'Введите номер накладной, заказа или код пункта выдачи с номером рейса.',
      inputLabel: 'Номер накладной или заказа',
      inputPlaceholder: 'Например, BX00000001-1',
      hint: 'Укажите номер полностью, вместе с буквами и дефисами.',
      recent: 'Последние запросы',
      placeholderTitle: 'Весь путь отправления на одном экране',
      placeholderText: 'Посмотрите текущий статус, направление, плановую дату и подробную историю движения.',
      loadingTitle: 'Проверяем отправление',
      loadingText: 'Запрашиваем актуальный статус в системе POSTMAN.',
      errorTitle: 'Не удалось найти отправление',
      required: 'Введите номер накладной или заказа.',
      notFound: 'Отправление не найдено. Проверьте номер полностью или повторите запрос позже.',
      waybill: 'Накладная',
      delivered: 'Доставлено',
      returned: 'Возвращено',
      inTransit: 'В пути',
      receiver: 'Получатель',
      from: 'Откуда',
      to: 'Куда',
      pieces: 'Мест',
      weight: 'Вес',
      plannedDate: 'Плановая дата',
      deliveredTitle: 'Отправление вручено',
      returnedTitle: 'Отправление возвращено',
      route: 'Маршрут',
      history: 'История отправления',
      events: ['событие', 'события', 'событий'],
      emptyTimeline: 'Детали маршрута появятся после первого сканирования отправления.',
      defaultReceiver: 'Получатель',
      weightUnit: 'кг',
    },
    privacyPage: {
      eyebrow: 'Документы',
      title: 'Обработка персональных данных',
      intro: 'Настоящее согласие регулирует обработку данных, которые пользователь передаёт ТОО «POSTMAN» через форму обратной связи на сайте.',
      dataTitle: 'Какие данные обрабатываются',
      dataText: 'Имя, фамилия, контактный телефон, адрес электронной почты, организация и содержание обращения.',
      purposeTitle: 'Для чего нужны данные',
      purposeText: 'Чтобы ответить на обращение, уточнить параметры доставки, подготовить предложение и улучшать качество обслуживания.',
      termTitle: 'Срок и отзыв согласия',
      termText: 'Данные обрабатываются в течение срока, необходимого для ответа и выполнения требований законодательства Республики Казахстан. Согласие можно отозвать письмом на postman_kz@mail.ru.',
      back: 'Вернуться к форме',
    },
  },
  kk: {
    meta: {
      title: 'POSTMAN — Қазақстан бойынша жеткізу',
      description: 'Қазақстан бойынша құжаттар мен сәлемдемелерді онлайн қадағалаумен курьерлік жеткізу.',
    },
    common: {
      home: 'Басты бет',
      tracking: 'Қадағалау',
      services: 'Қызметтер',
      contacts: 'Байланыс',
      cabinet: 'Жеке кабинет',
      close: 'Жабу',
      noInfo: 'Ақпарат жоқ',
      search: 'Табу',
      searching: 'Ізделуде…',
      discussDelivery: 'Жеткізуді талқылау',
    },
    header: {
      homeLabel: 'POSTMAN, басты бет',
      openMenu: 'Мәзірді ашу',
      closeMenu: 'Мәзірді жабу',
      navigationLabel: 'Негізгі навигация',
      languageLabel: 'Сайт тілі',
    },
    footer: {
      description: 'Қазақстан бойынша курьерлік жөнелтілімдерді жеткізу.',
      navigation: 'Навигация',
      trackShipment: 'Жөнелтілімді қадағалау',
      contact: 'Байланысу',
      company: '«POSTMAN» ЖШС',
      madeBy: 'Студия әзірледі:',
      privacy: 'Дербес деректерді өңдеу',
    },
    home: {
      businessQuestion: 'Бизнеске жеткізу керек пе?',
      discussTask: 'Тапсырманы талқылау →',
      eyebrow: 'Қазақстан бойынша курьерлік қызмет',
      titleBefore: 'Әр кезеңі көрінетін',
      titleEmphasis: 'жеткізу',
      lead: 'Қазақстан бойынша құжаттар мен сәлемдемелерді жеткізуді ұйымдастырамыз. Жөнелтілім мәртебесін бақылап, әр кезеңдегі өзекті ақпаратты алыңыз.',
      trackLabel: 'Жөнелтілімді қадағалау',
      trackPlaceholder: 'Жүкқұжат немесе тапсырыс нөмірі',
      check: 'Тексеру',
      trackingRequired: 'Жүкқұжат немесе тапсырыс нөмірін енгізіңіз.',
      trackingNotFound: 'Жөнелтілім табылмады. Нөмірді толық тексеріңіз немесе кейінірек қайталап көріңіз.',
      heroAlt: 'Жеткізу көлігінің жанында сәлемдеме ұстаған POSTMAN курьері',
      doorToDoor: 'Есіктен есікке дейін жеткізу',
      resultEyebrow: 'Іздеу нәтижесі',
      resultTitle: 'Жөнелтілімді қадағалау',
      closeResult: 'Қадағалау нәтижесін жабу',
      trust: ['Жеке автопарк', 'Толық қадағалау', 'Есікке дейін жеткізу', 'Бүкіл Қазақстан бойынша'],
      servicesEyebrow: 'Не жеткіземіз',
      servicesTitle: 'Артық күрделіліксіз логистика',
      allServices: 'Барлық қызметтер →',
      serviceCards: [
        { title: 'Экспресс-жеткізу', text: 'Қазақстан қалалары арасында құжаттар мен сәлемдемелерді түсінікті мерзімдермен және мәртебелермен жеткізу.' },
        { title: 'Бизнеске арналған жеткізу', text: 'Тұрақты жөнелтілімдер, жеке автопарк және тапсырыстарды басқаруға арналған жеке кабинет.' },
        { title: 'Шалғай мекенжайларға дейін', text: 'Ірі қалалар, аудан орталықтары, ауылдар мен елді мекендер бір жеткізу желісінде.' },
      ],
      learnMore: 'Толығырақ',
      partnerEyebrow: 'Үлкен көлеммен дәлелденген',
      partnerTitle: 'Қазақстандағы серіктестік желілерге арналған жеткізу',
      partnerLogosLabel: 'POSTMAN серіктестері',
      partnerText: 'Мыңдаған тапсырыс біздің желі арқылы өтеді. Қабылдаудан табыстауға дейінгі әр кезең жүйеде тіркеледі.',
      stepsEyebrow: 'Бұл қалай жұмыс істейді',
      stepsTitle: 'Алушыға дейінгі үш қадам',
      steps: [
        { title: 'Жөнелтілім жасаңыз', text: 'Өтінім қалдырыңыз немесе жеке кабинетте тапсырыс рәсімдеңіз.' },
        { title: 'Курьерге беріңіз', text: 'Жөнелтілімді алып, жүйеде тіркейміз.' },
        { title: 'Онлайн қадағалаңыз', text: 'Жүкқұжат нөмірі бойынша қозғалысын және табысталуын тексеріңіз.' },
      ],
      ctaEyebrow: 'Тапсырма бар ма?',
      ctaTitle: 'Маршрут пен жеткізу форматын таңдаймыз',
      ctaText: 'Нені және қайда жіберу керегін айтыңыз. Жауап беріп, қолайлы нұсқаны ұсынамыз.',
      ctaButton: 'Бізге жазу',
    },
    servicesPage: {
      eyebrow: 'POSTMAN қызметтері',
      title: 'Жеке тұлғалар мен бизнеске Қазақстан бойынша жеткізу',
      lead: 'Қабылдаудан табыстауға дейінгі жолды өз мойнымызға алып, жөнелтілім қозғалысын онлайн көрсетеміз.',
      items: [
        ['Құжаттар', 'Қорғаныш конверттері және іскерлік хат-хабарларды жылдам жеткізу.'],
        ['Сәлемдемелер', 'Жеке клиенттер мен интернет-дүкендердің Қазақстан бойынша жөнелтілімдері.'],
        ['Тұрақты рейстер', 'Тұрақты жөнелтілім көлемі бар компанияларға болжамды логистика.'],
        ['Мекенжай бойынша жеткізу', 'Шалғай елді мекендерді қоса алғанда, мекенжайдан алып кету және табыстау.'],
      ],
      rates: 'Тарифтер',
      ratesTitle: 'Құны маршрут пен жөнелтілім параметрлеріне байланысты',
      ratesText: 'Нақты есептеу үшін жөнелту және алу қаласын, салмағын, өлшемдерін және қажетті мерзімді көрсетіңіз.',
      getQuote: 'Есеп алу',
      beforeSending: 'Жөнелтер алдында',
      packingTitle: 'Дұрыс қаптау жолы',
      packing: [
        'Әр орынға байланыс деректерін жазыңыз.',
        'Сәйкес өлшемдегі берік қорапты пайдаланыңыз.',
        'Ішіндегі зат қозғалмауы үшін бос орынды толтырыңыз.',
        'Ашылатын жерлерін жабыстырып, сынғыш жүкті белгілеңіз.',
      ],
      helpTitle: 'Стандартты емес жөнелтілім бойынша көмек керек пе?',
      helpText: 'Тапсырманы сипаттаңыз, менеджер қаптау, мерзім және маршрут бойынша кеңес береді.',
      contactUs: 'Бізбен байланысу →',
    },
    contactsPage: {
      eyebrow: 'Байланыс',
      title: 'Жеткізуіңізді талқылайық',
      lead: 'Жөнелтілім туралы сұраққа жауап береміз, маршрутты есептейміз немесе бизнеске ұсыныс дайындаймыз.',
      phone: 'Телефон',
      call: 'Қоңырау шалу →',
      email: 'Электрондық пошта',
      write: 'Жазу →',
      office: 'Бас кеңсе',
      address: 'ҚР, индексі A20F2X1 (050034), Алматы қ., Жетісу ауданы, Ниязбекова көш., 33-үй',
      map: 'Картаны ашу ↗',
      requisites: 'Деректемелер',
      requisitesLabels: ['Компания', 'СТН', 'БСН', 'БСК', 'Банк', 'IBAN', 'ҚҚС бойынша куәлік', 'Заңды мекенжай', 'Директор'],
      formEyebrow: 'Кері байланыс нысаны',
      formTitle: 'Бізге жазыңыз',
      requiredHint: 'Жұлдызшамен белгіленген өрістер міндетті.',
      firstName: 'Аты *',
      lastName: 'Тегі',
      organization: 'Компания',
      phoneRequired: 'Телефон *',
      emailRequired: 'Email *',
      message: 'Хабарлама *',
      messagePlaceholder: 'Сізге қалай көмектесе алатынымызды жазыңыз',
      agreementBefore: 'Мен',
      agreementLink: 'дербес деректерді өңдеуге келісемін',
      agreementError: 'Дербес деректерді өңдеуге келісімді растаңыз.',
      sending: 'Жіберілуде…',
      submit: 'Хабарлама жіберу',
      success: 'Хабарлама жіберілді. Жұмыс уақытында сізбен байланысамыз.',
      error: 'Хабарлама жіберілмеді. Бізге қоңырау шалыңыз: {phone}.',
    },
    trackingPage: {
      eyebrow: 'Жүйедегі өзекті деректер',
      title: 'Жөнелтілімді қадағалау',
      lead: 'Жүкқұжат, тапсырыс немесе рейс нөмірі бар беру пунктінің кодын енгізіңіз.',
      inputLabel: 'Жүкқұжат немесе тапсырыс нөмірі',
      inputPlaceholder: 'Мысалы, BX00000001-1',
      hint: 'Нөмірді әріптерімен және дефистерімен бірге толық енгізіңіз.',
      recent: 'Соңғы сұраулар',
      placeholderTitle: 'Жөнелтілімнің бүкіл жолы бір экранда',
      placeholderText: 'Ағымдағы мәртебені, бағытты, жоспарланған күнді және қозғалыс тарихын көріңіз.',
      loadingTitle: 'Жөнелтілім тексерілуде',
      loadingText: 'POSTMAN жүйесінен өзекті мәртебені сұрап жатырмыз.',
      errorTitle: 'Жөнелтілім табылмады',
      required: 'Жүкқұжат немесе тапсырыс нөмірін енгізіңіз.',
      notFound: 'Жөнелтілім табылмады. Нөмірді толық тексеріңіз немесе кейінірек қайталап көріңіз.',
      waybill: 'Жүкқұжат',
      delivered: 'Жеткізілді',
      returned: 'Қайтарылды',
      inTransit: 'Жолда',
      receiver: 'Алушы',
      from: 'Қайдан',
      to: 'Қайда',
      pieces: 'Орын саны',
      weight: 'Салмақ',
      plannedDate: 'Жоспарланған күн',
      deliveredTitle: 'Жөнелтілім табысталды',
      returnedTitle: 'Жөнелтілім қайтарылды',
      route: 'Бағыт',
      history: 'Жөнелтілім тарихы',
      events: ['оқиға', 'оқиға', 'оқиға'],
      emptyTimeline: 'Бағыт мәліметтері жөнелтілім алғаш сканерленгеннен кейін пайда болады.',
      defaultReceiver: 'Алушы',
      weightUnit: 'кг',
    },
    privacyPage: {
      eyebrow: 'Құжаттар',
      title: 'Дербес деректерді өңдеу',
      intro: 'Осы келісім пайдаланушының сайттағы кері байланыс нысаны арқылы «POSTMAN» ЖШС-не беретін деректерін өңдеуді реттейді.',
      dataTitle: 'Қандай деректер өңделеді',
      dataText: 'Аты, тегі, байланыс телефоны, электрондық пошта мекенжайы, ұйымы және өтініш мазмұны.',
      purposeTitle: 'Деректер не үшін қажет',
      purposeText: 'Өтінішке жауап беру, жеткізу параметрлерін нақтылау, ұсыныс дайындау және қызмет сапасын жақсарту үшін.',
      termTitle: 'Келісім мерзімі және оны қайтарып алу',
      termText: 'Деректер жауап беруге және Қазақстан Республикасы заңнамасының талаптарын орындауға қажетті мерзім ішінде өңделеді. Келісімді postman_kz@mail.ru мекенжайына хат жолдау арқылы қайтарып алуға болады.',
      back: 'Нысанға оралу',
    },
  },
  en: {
    meta: {
      title: 'POSTMAN — delivery across Kazakhstan',
      description: 'Courier delivery of documents and parcels across Kazakhstan with online tracking.',
    },
    common: {
      home: 'Home',
      tracking: 'Tracking',
      services: 'Services',
      contacts: 'Contacts',
      cabinet: 'Customer portal',
      close: 'Close',
      noInfo: 'No information',
      search: 'Find',
      searching: 'Searching…',
      discussDelivery: 'Discuss delivery',
    },
    header: {
      homeLabel: 'POSTMAN, home',
      openMenu: 'Open menu',
      closeMenu: 'Close menu',
      navigationLabel: 'Main navigation',
      languageLabel: 'Website language',
    },
    footer: {
      description: 'Courier delivery throughout Kazakhstan.',
      navigation: 'Navigation',
      trackShipment: 'Track a shipment',
      contact: 'Contact us',
      company: 'POSTMAN LLP',
      madeBy: 'Made by',
      privacy: 'Personal data processing',
    },
    home: {
      businessQuestion: 'Need delivery for your business?',
      discussTask: 'Discuss your needs →',
      eyebrow: 'Courier service across Kazakhstan',
      titleBefore: 'Delivery you can follow',
      titleEmphasis: 'at every stage',
      lead: 'We arrange document and parcel delivery throughout Kazakhstan. Follow shipment status and receive up-to-date information at every stage.',
      trackLabel: 'Track a shipment',
      trackPlaceholder: 'Waybill or order number',
      check: 'Check',
      trackingRequired: 'Enter a waybill or order number.',
      trackingNotFound: 'Shipment not found. Check the full number or try again later.',
      heroAlt: 'POSTMAN courier holding a parcel beside a delivery vehicle',
      doorToDoor: 'Door-to-door delivery',
      resultEyebrow: 'Search result',
      resultTitle: 'Shipment tracking',
      closeResult: 'Close tracking result',
      trust: ['Our own fleet', 'Detailed tracking', 'Door delivery', 'Across Kazakhstan'],
      servicesEyebrow: 'What we deliver',
      servicesTitle: 'Logistics without unnecessary complexity',
      allServices: 'All services →',
      serviceCards: [
        { title: 'Express delivery', text: 'Documents and parcels between cities in Kazakhstan with clear timeframes and statuses.' },
        { title: 'Business delivery', text: 'Regular shipments, our own fleet and a customer portal for managing orders.' },
        { title: 'Remote addresses', text: 'Major cities, district centres, villages and remote communities in one delivery network.' },
      ],
      learnMore: 'Learn more',
      partnerEyebrow: 'Proven at scale',
      partnerTitle: 'Delivery for partner networks across Kazakhstan',
      partnerLogosLabel: 'POSTMAN partners',
      partnerText: 'Thousands of orders pass through our network. Every stage, from acceptance to handover, is recorded in the system.',
      stepsEyebrow: 'How it works',
      stepsTitle: 'Three steps to the recipient',
      steps: [
        { title: 'Create a shipment', text: 'Submit a request or place an order in the customer portal.' },
        { title: 'Hand it to a courier', text: 'We collect the shipment and register it in the system.' },
        { title: 'Track it online', text: 'Follow its journey and final delivery using the waybill number.' },
      ],
      ctaEyebrow: 'Have a delivery need?',
      ctaTitle: 'We will choose the right route and delivery format',
      ctaText: 'Tell us what you need to send and where. We will reply with a suitable option.',
      ctaButton: 'Contact us',
    },
    servicesPage: {
      eyebrow: 'POSTMAN services',
      title: 'Delivery across Kazakhstan for individuals and businesses',
      lead: 'We handle the journey from acceptance to handover and show shipment progress through online tracking.',
      items: [
        ['Documents', 'Protective envelopes and fast delivery of business correspondence.'],
        ['Parcels', 'Shipments for individuals and online stores throughout Kazakhstan.'],
        ['Regular routes', 'Predictable logistics for companies with a steady shipment volume.'],
        ['Address delivery', 'Collection and handover at the address, including remote communities.'],
      ],
      rates: 'Rates',
      ratesTitle: 'The price depends on the route and shipment details',
      ratesText: 'For an accurate quote, provide the origin and destination cities, weight, dimensions and required delivery time.',
      getQuote: 'Get a quote',
      beforeSending: 'Before sending',
      packingTitle: 'How to pack correctly',
      packing: [
        'Add contact details to every package.',
        'Use a sturdy box of the appropriate size.',
        'Fill empty space so the contents do not move.',
        'Seal all openings and label fragile cargo.',
      ],
      helpTitle: 'Need help with a non-standard shipment?',
      helpText: 'Describe your needs and a manager will advise you on packing, timeframes and the route.',
      contactUs: 'Contact us →',
    },
    contactsPage: {
      eyebrow: 'Contacts',
      title: 'Let’s discuss your delivery',
      lead: 'We can answer a shipment question, calculate a route or prepare a business proposal.',
      phone: 'Phone',
      call: 'Call →',
      email: 'Email',
      write: 'Write →',
      office: 'Head office',
      address: '33 Niyazbekova St, Zhetysu District, Almaty, A20F2X1 (050034), Kazakhstan',
      map: 'Open map ↗',
      requisites: 'Company details',
      requisitesLabels: ['Company', 'RNN', 'BIN', 'BIC', 'Bank', 'IBAN', 'VAT certificate', 'Legal address', 'Director'],
      formEyebrow: 'Feedback form',
      formTitle: 'Write to us',
      requiredHint: 'Fields marked with an asterisk are required.',
      firstName: 'First name *',
      lastName: 'Last name',
      organization: 'Company',
      phoneRequired: 'Phone *',
      emailRequired: 'Email *',
      message: 'Message *',
      messagePlaceholder: 'Tell us how we can help',
      agreementBefore: 'I agree to the',
      agreementLink: 'processing of personal data',
      agreementError: 'Please consent to the processing of personal data.',
      sending: 'Sending…',
      submit: 'Send message',
      success: 'Your message has been sent. We will contact you during business hours.',
      error: 'The message could not be sent. Call us at {phone}.',
    },
    trackingPage: {
      eyebrow: 'Current system data',
      title: 'Shipment tracking',
      lead: 'Enter a waybill number, order number, or pickup point code with the route number.',
      inputLabel: 'Waybill or order number',
      inputPlaceholder: 'For example, BX00000001-1',
      hint: 'Enter the full number, including letters and hyphens.',
      recent: 'Recent searches',
      placeholderTitle: 'The entire shipment journey on one screen',
      placeholderText: 'See the current status, route, planned date and detailed movement history.',
      loadingTitle: 'Checking the shipment',
      loadingText: 'Requesting the current status from the POSTMAN system.',
      errorTitle: 'Shipment not found',
      required: 'Enter a waybill or order number.',
      notFound: 'Shipment not found. Check the full number or try again later.',
      waybill: 'Waybill',
      delivered: 'Delivered',
      returned: 'Returned',
      inTransit: 'In transit',
      receiver: 'Recipient',
      from: 'From',
      to: 'To',
      pieces: 'Packages',
      weight: 'Weight',
      plannedDate: 'Planned date',
      deliveredTitle: 'Shipment delivered',
      returnedTitle: 'Shipment returned',
      route: 'Route',
      history: 'Shipment history',
      events: ['event', 'events', 'events'],
      emptyTimeline: 'Route details will appear after the shipment is scanned for the first time.',
      defaultReceiver: 'Recipient',
      weightUnit: 'kg',
    },
    privacyPage: {
      eyebrow: 'Documents',
      title: 'Personal data processing',
      intro: 'This consent governs the processing of data submitted by the user to POSTMAN LLP through the website feedback form.',
      dataTitle: 'Data we process',
      dataText: 'First name, last name, contact phone number, email address, organisation and the contents of the request.',
      purposeTitle: 'Why we need the data',
      purposeText: 'To answer the request, clarify delivery details, prepare a proposal and improve service quality.',
      termTitle: 'Consent period and withdrawal',
      termText: 'Data is processed for the period required to respond and comply with the laws of the Republic of Kazakhstan. Consent can be withdrawn by emailing postman_kz@mail.ru.',
      back: 'Return to the form',
    },
  },
};

export const languageOptions = [
  { code: 'ru', label: 'RU', name: 'Русский' },
  { code: 'kk', label: 'KZ', name: 'Қазақша' },
  { code: 'en', label: 'EN', name: 'English' },
];
